import { Grid } from '@mui/material';
import React, { useContext } from 'react';
import FormPartial from '../../../components/form/formContainer/FormPartial';
import SelectInput from '../../../components/form/formInputs/SelectInput/SelectInput';
import SettingsContext from '../../../contexts/settings.context';
import TextInput from '../../../components/form/formInputs/TextInput/TextInput';
import { SettingSectionProps } from './AccountingSettings';

const FormulationSettings = ({ onChange }: SettingSectionProps) => {
    const { settings } = useContext(SettingsContext);

    return (
        <FormPartial title={'Formulation Settings'}>
            <Grid container spacing={2}>
                <Grid item xs={6}>
                    <TextInput
                        id={'h20Density'}
                        onChange={(event: any) =>
                            onChange(event, 'formulationSettings')
                        }
                        fullWidth
                        value={settings.formulationSettings?.h20Density}
                        label="H20 Density Basis"
                    />
                </Grid>
                <Grid item xs={6}>
                    <SelectInput
                        id={'densityUnit'}
                        onChange={(event: any) =>
                            onChange(event, 'formulationSettings')
                        }
                        fullWidth
                        value={settings.formulationSettings?.densityUnit}
                        label="Density Unit"
                        options={[
                            { label: 'lbs/gal', value: 'lbs/gal' },
                            { label: 'kg/m3', value: 'kg/m3' },
                            { label: 'g/ml', value: 'g/ml' },
                        ]}
                    />
                </Grid>
                <Grid item xs={6}>
                    <SelectInput
                        id={'itemWeight'}
                        onChange={(event: any) =>
                            onChange(event, 'formulationSettings')
                        }
                        fullWidth
                        value={settings.formulationSettings?.itemWeight}
                        label="Item Weight Type"
                        options={[
                            { label: 'Net', value: 'net' },
                            { label: 'Gross', value: 'gross' },
                        ]}
                    />
                </Grid>
                <Grid item xs={6}>
                    <SelectInput
                        id={'equationControls'}
                        onChange={(event: any) =>
                            onChange(event, 'formulationSettings')
                        }
                        fullWidth
                        value={settings.formulationSettings?.equationControls}
                        label="Equation Controls"
                        options={[
                            { label: 'Immediate', value: 'immediate' },
                            { label: 'On Demand', value: 'ondemand' },
                        ]}
                    />
                </Grid>
                <Grid item xs={6}>
                    <SelectInput
                        id={'revisionDigits'}
                        onChange={(event: any) =>
                            onChange(event, 'formulationSettings')
                        }
                        fullWidth
                        value={settings.formulationSettings?.revisionDigits}
                        label="Revision Digits"
                        options={[
                            { label: '1', value: '1' },
                            { label: '2', value: '2' },
                            { label: '3', value: '3' },
                            { label: '4', value: '4' },
                            { label: '5', value: '5' },
                        ]}
                    />
                </Grid>
                <Grid item xs={6}>
                    <TextInput
                        id={'revisionPrefix'}
                        onChange={(event: any) =>
                            onChange(event, 'formulationSettings')
                        }
                        fullWidth
                        value={settings.formulationSettings?.revisionPrefix}
                        label="Revision Prefix"
                    />
                </Grid>
                <Grid item xs={6}>
                    <TextInput
                        id={'componentStepNo'}
                        onChange={(event: any) =>
                            onChange(event, 'formulationSettings')
                        }
                        fullWidth
                        value={settings.formulationSettings?.componentStepNo}
                        label="Component Step No."
                    />
                </Grid>
            </Grid>
        </FormPartial>
    );
};

export default FormulationSettings;
